
const CLAVE = "diagnosticos_asistencia_pendientes";
const MAX_ERRORES = 100;

export function guardarErrorAsistencia({
    accion,
    error,
    tipo = "TECNICO",
    idEmpleado = null,
    idSucursal = null,
    idRegional = null,
    detalles = {}
}) {
    try {
        const fecha = new Date();

        const registro = {
            id: typeof crypto !== "undefined" &&
                typeof crypto.randomUUID === "function"
                    ? crypto.randomUUID()
                    : `${Date.now()}-${Math.random().toString(36).slice(2)}`,
            fechaHora: fecha.toISOString(),
            fechaLocal: fecha.toLocaleString("es-BO"),
            tipo,
            accion,
            mensaje: String(
                error?.message ??
                error ??
                "Error sin mensaje"
            ).slice(0, 1000),
            stack: typeof error?.stack === "string"
                ? error.stack.slice(0, 3000)
                : null,
            idEmpleado,
            idSucursal,
            idRegional,
            detalles,
            url: window.location.pathname,
            navegador: navigator.userAgent
        };

        let anteriores = [];

        try {
            const datos = JSON.parse(
                localStorage.getItem(CLAVE) || "[]"
            );
            anteriores = Array.isArray(datos) ? datos : [];
        } catch {
            anteriores = [];
        }

        anteriores.push(registro);

        localStorage.setItem(
            CLAVE,
            JSON.stringify(anteriores.slice(-MAX_ERRORES))
        );

        console.error("Diagnóstico registrado:", registro);

        return registro;

    } catch (errorGuardado) {
        console.error(
            "No se pudo guardar el diagnóstico:",
            errorGuardado
        );
        return null;
    }
}

export async function enviarErroresPendientes(server) {
    const pendientes = JSON.parse(
        localStorage.getItem(CLAVE) || "[]"
    );

    if (!Array.isArray(pendientes) || pendientes.length === 0) {
        return;
    }

    // Evitar dos envíos simultáneos en la misma pestaña.
    if (enviarErroresPendientes.enviando) return;
    enviarErroresPendientes.enviando = true;

    try {
        const respuesta = await fetch(
            `${server}/api/asistencia/diagnosticos`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    errores: pendientes
                }),
                signal: AbortSignal.timeout(15000)
            }
        );

        if (!respuesta.ok) {
            throw new Error(`HTTP ${respuesta.status}`);
        }

        const data = await respuesta.json();

        if (data.success !== true) {
            throw new Error("El servidor no confirmó el guardado");
        }

        // Eliminar únicamente los registros confirmados.
        const idsEnviados = new Set(pendientes.map(e => e.id));

        const actuales = JSON.parse(
            localStorage.getItem(CLAVE) || "[]"
        );

        localStorage.setItem(
            CLAVE,
            JSON.stringify(
                actuales.filter(e => !idsEnviados.has(e.id))
            )
        );

        console.log("Diagnósticos enviados correctamente");

    } catch (error) {
        console.warn(
            "Diagnósticos pendientes para el próximo intento:",
            error
        );
    } finally {
        enviarErroresPendientes.enviando = false;
    }
}

let escuchadoresInstalados = false;

export function activarDiagnosticosJavaScript() {
    if (escuchadoresInstalados) return;

    escuchadoresInstalados = true;

    window.addEventListener("error", (event) => {
        guardarErrorAsistencia({
            accion: "ERROR_JAVASCRIPT",
            tipo: "TECNICO",
            error: event.error || event.message,
            detalles: {
                archivo: event.filename || null,
                linea: event.lineno || null,
                columna: event.colno || null
            }
        });
    });

    window.addEventListener("unhandledrejection", (event) => {
        guardarErrorAsistencia({
            accion: "PROMESA_RECHAZADA",
            tipo: "TECNICO",
            error: event.reason || "Promesa rechazada"
        });
    });
}